import type { ChipProps } from "@mui/material";

/**
 * Maps a DiagnosisCategory string to a semantic MUI Chip color.
 */
export function categoryChipColor(category: string): ChipProps["color"] {
  switch (category) {
    case "code_bug":
      return "error";
    case "data_problem":
      return "warning";
    case "portal_issue":
      return "info";
    case "credential_issue":
      return "secondary";
    case "qc_failure":
    default:
      return "default";
  }
}

/**
 * Returns a MUI Chip color based on confidence level.
 * ≥80% → success (green), 50-79% → warning (yellow), <50% → error (red)
 */
export function confidenceChipColor(confidence: number): ChipProps["color"] {
  if (confidence >= 0.8) return "success";
  if (confidence >= 0.5) return "warning";
  return "error";
}
